import React, { useEffect, useState } from "react";
import Slider from "@react-native-community/slider";
import { StyleSheet, TouchableOpacity, Text, View } from "react-native";

export function CitasDrawer(props) {
  return (
    <View style={styles.container}>
      {props.elements.length == 0 && (
        <Text style={styles.label}>Seleccione una hora</Text>
      )}
      {props.elements.map((e) => {
        if (e < 10) e = "0" + e;
        if (props.disabled.indexOf(e) < 0)
          return (
            <TouchableOpacity onPress={() => props.onChangeHandler(e)} key={e}>
              <Text style={styles.label}>{e}</Text>
            </TouchableOpacity>
          );
        else
          return (
            <TouchableOpacity disabled={true} key={e}>
              <Text style={styles.disabled}>{e}</Text>
            </TouchableOpacity>
          );
      })}
    </View>
  );
}

export function DuracionDrawer(props) {
  const [horas, setHoras] = useState(parseInt(props.min / 60));
  const [minutos, setMinutos] = useState(props.min);
  useEffect(() => {
    setMinutos(props.min);
    setHoras(parseInt(props.min / 60));
  }, [props.max]);
  useEffect(() => {
    const minutosCopy = minutos;
    props.onChangeHandler(parseInt(minutos));
    setHoras(parseInt(minutosCopy / 60));
  }, [minutos]);
  return (
    <View style={styles.container}>
      <Text style={styles.label}>
        {"  "}
        {horas ? (horas == 1 ? horas + " hora " : horas + " horas ") : ""}
        {(minutos % 60) + " minutos"}
      </Text>
      <Slider
        value={props.min}
        style={{ width: "100%", height: 30 }}
        minimumValue={props.min}
        maximumValue={props.max}
        step={props.step}
        thumbTintColor='#3E4672'
        minimumTrackTintColor='#3E4672'
        disabled={props.disabled}
        onValueChange={(value) => setMinutos(value + "")}></Slider>
    </View>
  );
}

const styles = StyleSheet.create({
  disabled: {
    fontFamily: "Nunito-Bold",
    fontSize: 17,
    textAlign: "center",
    lineHeight: 38,
    color: "darkgray",
    margin: 5,
  },
  label: {
    fontFamily: "Nunito-Bold",
    fontSize: 17,
    textAlign: "center",
    lineHeight: 38,
    color: "#3E4672",
    margin: 5,
  },
  container: {
    width: 300,
    backgroundColor: "white",
    borderColor: "#CACACA",
    borderWidth: 1,
    borderRadius: 15,
    padding: 10,
    alignSelf: "center",
    flexDirection: "row",
    flexWrap: "wrap",
  },
});
